export const handlePopupVisibility = (visibility, isFeedback = false) => {
    if (typeof document === "undefined" || typeof window === "undefined") return;

    const $body = document.querySelector("body");
    const $head = document.querySelector("head");

    if (!$body || !$head) return; // Safeguard in case elements are not found

    if (visibility) {
        if (!isFeedback) {
            // Add classes to prevent scrolling
            $body.classList.add("disable-scroll");
        }
    } else {
        if (!isFeedback) {
            $body.classList.remove("disable-scroll");
        }
    }
};